import { escapeHtml } from "./html.js";

// Simbolo padrao de empty state do app (circulo tracejado + X).
// Fonte unica do simbolo; use via renderEmptyState/EMPTY_STATE_SVG.
export const EMPTY_STATE_SVG = `<svg width="78" height="78" viewBox="0 0 78 78" fill="none" aria-hidden="true"><circle cx="39" cy="39" r="28" stroke="rgba(255,255,255,0.14)" stroke-width="2" stroke-dasharray="4 4"/><path d="M33 44l-4-4 4-4M45 44l4-4-4-4" stroke="rgba(255,255,255,0.22)" stroke-width="2" stroke-linecap="round"/></svg>`;

// Monta o bloco padrao de empty state.
// options:
//   className -> classes extras no container (ex.: "questions-empty-state").
//   size      -> tamanho do simbolo em px (padrao 78).
//   ctaHtml   -> HTML extra (ex.: botao de acao).
export function renderEmptyState(text, options = {}) {
  const { className = "", size = 78, ctaHtml = "" } = options;
  const svg = size === 78
    ? EMPTY_STATE_SVG
    : EMPTY_STATE_SVG.replace('width="78" height="78"', `width="${size}" height="${size}"`);
  return `<div class="empty-state ${className}">${svg}<p>${escapeHtml(text)}</p>${ctaHtml}</div>`;
}
